export default "__VITE_ASSET__DmPB53cB__"